import { companyDetailSchema, companyRelationSchema } from '@/schemas/companySchema';
import { officeDetailSchema, officeRelationSchema } from '@/schemas/officeSchema';
import { z } from 'zod';

export type AgentResultType = z.infer<typeof agentLazySchema>;
export type AgentDetailType = z.infer<typeof agentDetailSchema>;

export const agentRelationSchema = z.object({
  id: z.number(),
  name: z.string(),
  shortName: z.string(),
});

export const agentLazySchema = agentRelationSchema.extend({
  officeId: officeRelationSchema.shape.id,
  officeName: officeRelationSchema.shape.name,
  officeShortName: officeRelationSchema.shape.shortName,
  companyId: companyRelationSchema.shape.id.optional(), // Optional because there's no company link yet in Kotipro
  companyName: companyRelationSchema.shape.name.optional(), // Optional because there's no company link yet in Kotipro
  companyShortName: companyRelationSchema.shape.shortName.optional(), // Optional because there's no company link yet in Kotipro
});

export const agentDetailSchema = z.object({
  agentId: z.number(),
  name: z.string(),
  title: z.string(),
  email: z.string(),
  phone: z.string(),
  mobile: z.string(),
  officeId: z.number(),
  hidden: z.boolean(),
  info: z.array(z.string()),
  experience: z.array(z.string()),
  languageSkills: z.array(z.string()),
  references: z.array(z.string()),
  pictureUrl: z.string().optional(),
  shortName: z.string(),
  regionIds: z.array(z.number()),
  company: companyRelationSchema,
  office: officeRelationSchema.optional(),
});

export const agentFullSchema = agentDetailSchema.extend({
  company: companyDetailSchema,
  office: officeDetailSchema,
});
